<template>
  <v-container fluid fill-height>
    <v-layout align-center justify-center>
      <v-flex xs12 sm8 md4>
        <v-form ref="form" @submit="Confirm" lazy-validation>
          <v-card class="elevation-12">
            <v-card-title primary-title class="primary">
              <div class="headline white--text">Confirm Registration</div>
            </v-card-title>
            <v-card-text>
              <v-text-field
                autocomplete="username"
                prepend-icon="person"
                name="username"
                label="Username"
                :rules="nameRules"
                :disabled="loading"
                v-model="user.username"
                type="text">
              </v-text-field>
              <v-text-field
                prepend-icon="vpn_key"
                name="code"
                label="Verification Code"
                :rules="codeRules"
                :disabled="loading"
                v-model="user.code"
                type="text">
              </v-text-field>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                color="secondary"
                @click="Resend"
                :loading="loading"
                type="submit"
                :disabled="!this.user.username">
                Resend Verification Code
              </v-btn>
              <v-btn
                color="primary"
                @click="Confirm"
                :loading="loading"
                type="submit">
                Confirm
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-form>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
  import {mapActions, mapGetters} from 'vuex';

  export default {
    name: 'ConfirmSignUp',
    data() {
      return {
        loading: false,
        nameRules: [
          (v) => !!v || 'Username ist ein Pflichtfeld',
        ],
        codeRules: [
          (v) => !!v || 'Verification Code ist ein Pflichtfeld',
        ],
        user: {
          username: null,
          code: null,
        },
      };
    },
    computed: {
      ...mapGetters({
        username: 'guest/auth/username',
      }),
    },
    methods: {
      ...mapActions({
        resendSignUp: 'guest/auth/resendSignUp',
        confirmSignUp: 'guest/auth/confirmSignUp',
        showSnackbar: 'common/snackbar/success',
      }),
      Confirm(e) {
        e.preventDefault();
        if (this.$refs.form.validate()) {
          this.loading = true;
          this.confirmSignUp(this.user)
            .then((res) => {
              this.loading = false;
              if (res) {
                this.showSnackbar('User activated, you can log in now');
                this.$router.push({name: 'SignIn'});
              }
            });
        }
      },
      async Resend(e) {
        e.preventDefault();
        this.loading = true;
        await this.resendSignUp(this.user);
        this.loading = false;
      },
    },
    mounted() {
      if (this.username) {
        this.user.username = this.username;
      }
    },
  };
</script>

<style scoped>

</style>
